import { render, staticRenderFns } from "./ManageActions.vue?vue&type=template&id=23de6380&scoped=true"
import script from "./ManageActions.vue?vue&type=script&lang=js"
export * from "./ManageActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de6380",
  null
  
)

export default component.exports